import requests from "API/propertiesRequests";
import { useEffect, useState } from "react";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import Slider from "react-slick";
import { Grid } from "@mui/material";
import BackgroundBlogCard from "components/Cards/BlogCards/BackgroundBlogCard";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function MostVisited() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(requests.getMostVisited()).then(async (response) => {
      if (response.ok) {
        setData(await response.json());
      }
    });
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: true,
  };
  // console.log(data);
  return (
    <>
      <MKBox minHeight="15vh" width="100%">
        <Container>
          <MKBox p={3} position="relative">
            <MKTypography variant="h2">Más Visitados</MKTypography>
            <Slider {...settings}>
              {data.map((property) => (
                <>
                  <Grid
                    item
                    container
                    direction="column"
                    xs={12}
                    sm={6}
                    lg={4}
                    sx={{ padding: 1, height: "auto", width: "275" }}
                  >
                    <a href={`/details/${property.id}`}>
                      <BackgroundBlogCard
                        image={`https://administracionbiugb.ugb.edu.sv${
                          property.imagesproperty_set.map((item) => item.image_property)[0]
                        }`}
                        title={property.name}
                        description={property.suburb?.name}
                        action={{
                          type: "internal",
                          route: `/details/${property.id}`,
                          color: "info",
                          label: "Read More",
                        }}
                        views={property.views}
                      />
                    </a>
                  </Grid>
                </>
              ))}
            </Slider>
          </MKBox>
        </Container>
      </MKBox>
    </>
  );
}

export default MostVisited;
